import { Outlet } from "react-router-dom";
import { AdminSidebar } from "@/components/navigation/admin-sidebar";

export default function AdminLayout() {
  return (
    <div className="flex min-h-screen">
      <AdminSidebar />
      <main className="flex-1 overflow-auto lg:p-0 pt-14 lg:pt-0">
        <Outlet />
      </main>
    </div>
  );
}
